export default __webpack_public_path__ + "static/media/performance-tracking.ae9ca187.svg";